import _ from "lodash";
import React from "react";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
import {
  typesConfig,
  getFilterDataMemoized,
  getParseResultMemoized,
  getModuleTypeBySearchTerm,
} from "../Utils";
import { getGlobalSearchResult } from "../../modules/GlobalSearchBarQueries";
import { getGlobalSearchResultFromCache } from "../../modules/GlobalSearchBarHelper";
import I18nHOC from "UIComponents/I18nHOC";
import withLoader from "UIComponents/GqlWithLoader";
import { SearchList } from "../SearchList/SearchList";
import classes from "./Suggestions.scss";
import classNames from "classnames";

const Suggestions = props => {
  const {
    module,
    suggestions = [],
    suggestionModules,
    t,
    onSuggestionClick,
  } = props;

  const data =
    module === typesConfig.MODULES.id ? suggestionModules : suggestions;

  const suggestionLabelClass = classNames({
    [classes.suggestionLabel]: true,
    ["text-label-3"]: true,
  });

  return (
    <div className={classes.container} style={{ minHeight: 0 }}>
      <div className={suggestionLabelClass}>
        {t("common:suggestions_for_you")}
      </div>
      <div className={classes.listContainer}>
        <SearchList
          data={_.slice(data, 0, 4)}
          onSelectItem={onSuggestionClick}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const { module, t } = ownProps;

  const curriculumPrograms = state.platform.organizationCurriculumPrograms;

  const curriculumProgramType = _.map(curriculumPrograms, data => data.type);

  const { userInfo } = state.login;

  const suggestionModules =
    module === typesConfig.MODULES.id
      ? getModuleTypeBySearchTerm({
          term: "",
          orgId: userInfo.org_id,
          module,
          curriculumProgramType,
          userInfo,
          t,
        })
      : [];

  const filters = getFilterDataMemoized({
    state: state.platform,
    searchText: "",
    module,
  });

  return {
    isData: true,
    isLoading: false,
    filters,
    suggestionModules: getParseResultMemoized({ result: suggestionModules, t }),
  };
};

export default compose(
  I18nHOC({
    resource: [
      "common",
      "teacherHomePage",
      "classRoom",
      "configuration",
      "attendance",
      "integration",
    ],
  }),
  connect(mapStateToProps, null),
  graphql(getGlobalSearchResult, {
    name: "getGlobalSearchResultQuery",
    options: ({ filters }) => ({
      fetchPolicy: "cache-and-network",
      variables: filters,
    }),
    skip: props => {
      const { module } = props;
      return module == typesConfig.MODULES.id;
    },
    props: ({
      getGlobalSearchResultQuery,
      ownProps: { isData, isLoading, filters, t },
    }) => {
      const result = getGlobalSearchResultFromCache({
        filters,
      });

      const queryResult = _.get(result, "platform.platformSearch", []);

      const suggestions = getParseResultMemoized({
        result: queryResult,
        t,
      });

      return {
        suggestions,
        isData: !_.isEmpty(result) && isData,
        isLoading:
          _.includes([1, 2], getGlobalSearchResultQuery["networkStatus"]) ||
          isLoading,
      };
    },
  }),
  withLoader
)(Suggestions);
